// Module
var code = "<div class=\"component-editor-source component-editor-rest-api-source\">\n  <steps>\n    <step ng-model=\"authenticationStep\"></step>\n    <step ng-model=\"componentFormStep\"></step>\n    <step ng-model=\"schemaImporterStep\"></step>\n  </steps>\n</div>\n";
// Exports
module.exports = code;